import React from 'react'
import PropTypes from 'prop-types'
import WrappedModal from '@/components/WrappedModal'
import ReservationDetail from './ReservationDetail'

class ReservationDetailModal extends React.Component {
  modalRef = React.createRef()

  static propTypes = {
    onDispatch: PropTypes.func,
    onSuccess: PropTypes.func
  }

  state = {
    record: null
  }

  show = (record) => {
    this.setState({ record }, () => {
      this.modalRef.current?.showModal?.({ stopPropagation: () => {} })
    })
  }

  handleDispatch = (item) => {
    this.modalRef.current?.hideModal?.({ target: 'HTMLElement' })
    const { onDispatch } = this.props
    if (typeof onDispatch === 'function') onDispatch(item)
  }

  handleCancelSuccess = () => {
    this.modalRef.current?.hideModal?.({ target: 'HTMLElement' })
    const { onSuccess } = this.props
    if (typeof onSuccess === 'function') onSuccess()
  }

  handleClose = () => {
    this.modalRef.current?.hideModal?.({ target: 'HTMLElement' })
  }

  render () {
    const { record } = this.state
    const { onSuccess } = this.props
    return (
      <WrappedModal
        ref={this.modalRef}
        title="预约详情"
        footer={null}
        width={480}
        maskClosable={false}
        destroyOnClose={true}
        baseComponent={<ReservationDetail />}
        baseProps={{
          record,
          onDispatch: this.handleDispatch,
          onSuccess,
          onCancelSuccess: this.handleCancelSuccess,
          onClose: this.handleClose
        }}
      />
    )
  }
}

export default ReservationDetailModal
